import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Paper,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from "@mui/material";
import { getUsers } from "../../api/user.api";

function not(a, b) {
  return a.filter((value) => !b.includes(value));
}

function intersection(a, b) {
  return a.filter((value) => b.includes(value));
}

const CreateTeamModal = ({ open, handleClose, handleSubmit }) => {
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    members: [],
    teamCaptainId: "",
    isGenerated: false,
  });

  const initialFormData = {
    name: "",
    members: [],
    teamCaptainId: "",
    isGenerated: false,
  };

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  useEffect(() => {
    getUsers()
      .then((response) => {
        setLeft(response.data);
      })
      .catch((e) => console.log(e));
  }, [open]);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    formData.members = right;
    setLeft([]);
    setRight([]);
    handleSubmit(formData);
    setFormData(initialFormData);
    handleClose();
  };

  const onClose = () => {
    setLeft([]);
    setRight([]);
    handleClose();
  }

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const customList = (items, side, title) => {
    return (
      <div>
        <Typography>{title}</Typography>
        <Paper sx={{ width: 200, height: 300, overflow: "auto" }}>
          <List dense component="div" role="list">
            {items.map((user) => {
              const labelId = `transfer-list-item-${user.id}-label`;

              return (
                <ListItemButton
                  key={user.id + side}
                  role="listitem"
                  onClick={handleToggle(user)}
                >
                  <ListItemIcon>
                    <Checkbox checked={checked.includes(user)} />
                  </ListItemIcon>
                  <ListItemText id={labelId} primary={`${user.nickname}`} />
                </ListItemButton>
              );
            })}
          </List>
        </Paper>
      </div>
    );
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">Create Team</Typography>
          <div>
            <TextField
              id="name"
              label="Name"
              name="name"
              variant="outlined"
              type="text"
              fullWidth
              value={formData.name}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
            <Grid
              container
              spacing={2}
              sx={{ justifyContent: "center", alignItems: "center" }}
            >
              <Grid>{customList(left, "left", "Available Users")}</Grid>
              <Grid>
                <Grid
                  container
                  direction="column"
                  sx={{ alignItems: "center" }}
                >
                  <Button
                    sx={{ my: 0.5 }}
                    variant="outlined"
                    size="small"
                    onClick={handleCheckedRight}
                    disabled={leftChecked.length === 0}
                    aria-label="move selected right"
                  >
                    &gt;
                  </Button>
                  <Button
                    sx={{ my: 0.5 }}
                    variant="outlined"
                    size="small"
                    onClick={handleCheckedLeft}
                    disabled={rightChecked.length === 0}
                    aria-label="move selected left"
                  >
                    &lt;
                  </Button>
                </Grid>
              </Grid>
              <Grid>{customList(right, "right", "Choosen Players")}</Grid>
            </Grid>
          </div>
          <div>
            <FormControl fullWidth>
              <InputLabel id="select-captain-label">Team Captain</InputLabel>
              <Select
                labelId="select-captain-label"
                id="teamCaptainId"
                name="teamCaptainId"
                value={formData.teamCaptainId}
                label="Team Captain"
                onChange={handleChange}
              >
                {right.map((user) => (
                  <MenuItem key={"cap_" + user.id} value={user.id}>
                    {user.nickname}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateTeamModal;
